import React from "react";
import "../css/OurVision.css"; // Corrected the path

const OurVision = () => {
  return (
    <div className="our-vision">
      <h1>Our Vision</h1>
   <p>
   In the next five years, we strive to become the premier platform for Insurance Advisors, Mutual Fund Distributors, LIC Professionals, and Certified Financial Planners. Our mission is to empower these professionals by providing innovative tools and solutions to streamline client acquisition, management, and service delivery. By joining our platform, financial experts will gain a competitive edge and set new benchmarks in excellence and efficiency.
   </p>
    </div>
  );
};

export default OurVision;